module.exports = __webpack_public_path__ + "img/icon_hospital.38b58ddf.svg";